import { fetchAuthSession, signOut } from 'aws-amplify/auth';
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito';
import type { RawSession } from './types';

export const SESSION_ERROR_MESSAGE = 'Unable to fetch or refresh the current session.';

export const fetchSession = async (): Promise<RawSession> => {
  const session = await fetchAuthSession().catch(() => undefined);
  const idToken = session?.tokens?.idToken;

  if (idToken === undefined) {
    // must throw an error to prevent downstream requests
    throw new Error(SESSION_ERROR_MESSAGE);
  }

  return { idToken: idToken.toString(), claims: idToken.payload };
};

export const clearTokens = () => cognitoUserPoolsTokenProvider.tokenOrchestrator.clearTokens();

export const signOutAndClearTokens = async () => {
  await signOut();
  await clearTokens();
};
